import React, { InputHTMLAttributes, useCallback, useState} from 'react'
import { BsFillTrashFill } from 'react-icons/bs'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import TextareaInput from '../../Korbantech/components/Inputs/TextareaInput'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../Korbantech/components/Label'
import Modal from '../../Korbantech/components/Modal'
import { TrailModule } from '../../types/TrailModule'

export const ModulesFields = ({last,remove,newModule,module, ...props}:Props) => {

    const api = useApi()

    const [modalDelete,setModalDelete] = useState<boolean>()

    const handleDelete = useCallback( async ()=>{
        if(!module) return
        await api.delete(`admin/trails/module/${module.id}`).then(res =>{ 
                window.location.reload()
        }).catch(console.log)
    },[api,module])

    return(
    
        <div className='bg-white border shadow-md border-l-4 border-r-4 my-3 border-primary rounded-md p-3 '>
            <div className='text-lg font-bold flex justify-between'>
                    <div>Bloco {props.name}</div>
                    {remove && !module && <div className='text-xl'><BsFillTrashFill onClick={remove} /></div>}
                    {module && <div className='text-xl text-red-500'><BsFillTrashFill onClick={() => setModalDelete(true)} /></div>}
            </div>
            <Label>
                Texto: <span className='text-sm'>{"Para adicionar destaque adicione elas entre { } . exemplo { frase } "}</span>
                <TextareaInput required defaultValue={module ? module.text : ""} name={`modules[${props.name}][text]`} className={'h-32 bg-gray-100 rounded border border-gray-600 text-gray-700 my-'} />
            </Label>
            <Label>
                Link:
                <TextInput required defaultValue={module ? module.link : ""} name={`modules[${props.name}][link]`} type="url"
                className="bg-gray-100 rounded border border-gray-600 text-gray-700 my-" />
            </Label>
            <Label>
                Texto para o link: (ex. ver link)
                <TextInput required defaultValue={module ? module.link_name : ""} name={`modules[${props.name}][link_name]`}
                    className="bg-gray-100 rounded border border-gray-600 text-gray-700 my-" 
                />
            </Label>
            {module && 
            <div className="flex flex-col items-end mt-2">
                  <div className="w-5/12">
                      <SubmitButton value="Alterar Card" />
                  </div>
            </div>
            }
            {newModule && 
            <div className="flex flex-col items-end mt-2">
                  <div className="w-5/12">
                      <SubmitButton value="Salvar novo bloco" />
                  </div>
            </div>
            }
            <Modal open={modalDelete} onClickCloseButton={()=>setModalDelete(false)}>
                <div className='flex flex-col p-2'>
                    <strong>Deseja mesmo deletar o item :</strong>
                            {module?.text}
                        <div className='flex justify-between gap-x-2'>
                            <button className='bg-primary-dark mt-3 py-1 px-2 rounded-md' onClick={() => setModalDelete(false)}>
                                        Cancelar
                            </button>
                            <button className='bg-red-500 mt-3 py-1 px-2 rounded-md text-white' onClick={() => handleDelete()}>
                                        Confirmar e deletar
                            </button>
                        </div>
                    

                </div>
            </Modal>
        </div>
    )
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    last?: boolean
    remove?: () => void | undefined
    newModule?: boolean
    module?:TrailModule
}